import React from "react";

const Home = () => {
  return (
    <div className="container mx-auto my-8">
      <h1 className="text-3xl font-bold text-center mb-6">Welcome to my Fabacademy 2025 Website!</h1>
      <div className="flex justify-center">

      </div>

      <p className="text-center mt-6 text-lg">
        This is my personal website to document the progress I make during fabacademy 2025 😊
      </p>
    </div>
    
  );
};

export default Home;
